import request from '@/service/request'

// const get = (url, data) => {
//   return request({
//     url,
//     method: 'get',
//     data
//   })
// }

const post = (url, data) => {
  return request({
    url,
    method: 'post',
    data
  })
}

// 登录Kkday账号
export function loginForKKday(data) {
  return request({
    url: '/api/v3/kkpartners/account/login-for-kkday',
    method: 'post',
    data
  })
}

// 注册kkpartners账号和网站
export function register(data) {
  return request({
    url: '/api/v3/kkpartners/account/register',
    method: 'post',
    data
  })
}

// 验证邮箱
export function verifyEmail(data) {
  return request({
    url: '/api/v3/kkpartners/account/verify',
    method: 'post',
    data
  })
}

// 发送验证邮箱邮件
export function sendVerifyEmail(data) {
  return request({
    url: '/api/v3/kkpartners/account/send-verify-email',
    method: 'post',
    data
  })
}

// 登录
export function login(data) {
  return request({
    url: '/api/v3/kkpartners/account/login',
    method: 'post',
    data
  })
}

// 重置密码
export function resetPassword(data) {
  return request({
    url: '/api/v3/kkpartners/account/reset-password',
    method: 'post',
    data
  })
}

// 发送忘记密码邮件
export function sendForgetPasswordEmail(data) {
  return request({
    url: '/api/v3/kkpartners/account/send-forget-password-email',
    method: 'post',
    data
  })
}

// 获取当前账户信息
export function getAccountInfo(data) {
  return request({
    url: '/api/v3/kkpartners/account/info',
    method: 'get',
    data
  })
}

// 获取联盟网站列表
export function getWebsiteList(data) {
  return request({
    url: '/api/v3/kkpartners/web/list',
    method: 'get',
    data
  })
}

// 新增联盟网站
export function addWebsite(data) {
  return request({
    url: '/api/v3/kkpartners/web/add',
    method: 'post',
    data
  })
}

// 编辑个人户/公司户账户资料
export function editAccountInfo(data) {
  return request({
    url: '/api/v3/kkpartners/account/edit-account-info',
    method: 'post',
    data
  })
}

// 编辑付款资料
export function editPaymentInfo(data) {
  return request({
    url: '/api/v3/kkpartners/account/edit-payment-info',
    method: 'post',
    data
  })
}

// 编辑语系
export function editLanguage(data) {
  return request({
    url: '/api/v3/kkpartners/account/edit-language',
    method: 'post',
    data
  })
}

// 获取订单资讯列表
export function getTransactionList(data) {
  return request({
    url: '/api/v3/kkpartners/report/transaction-list',
    method: 'get',
    data
  })
}

// 下载订单资讯
export function downloadTransaction(data) {
  return request({
    url: '/api/v3/kkpartners/report/download-transaction',
    method: 'get',
    type: 'file',
    data
  })
}


// 异步下载订单资讯
export function downloadTransactionAsync(data) {
  return request({
    url: '/api/v3/kkpartners/report/async-download-transaction',
    method: 'get',
    data
  })
}

// 检测异步下载订单资讯
export function checkDownloadTransactionTask(data) {
  return request({
    url: '/api/v3/kkpartners/report/check-download-transaction-task',
    method: 'get',
    data
  })
}

// 取得結帳報表列表
export function getSettlementList(data) {
  return request({
    url: '/api/v3/kkpartners/report/get-settlement-list',
    method: 'get',
    data
  })
}

// 取得結帳報表列表
export function getOrderOverview(data) {
  return request({
    url: '/api/v3/kkpartners/report/get-order-overview',
    method: 'get',
    data
  })
}

// 结账报表详情列表
export function getSettlementDetailList(data) {
  return request({
    url: '/api/v3/kkpartners/report/settlement-detail-list',
    method: 'get',
    data
  })
}

// 下载结账报表详情列表
export function downloadSettlementDetail(data) {
  return request({
    url: '/api/v3/kkpartners/report/download-settlement-detail',
    method: 'get',
    type: 'file',
    data
  })
}

// 异步下载结账报表
export function downloadAsyncSettlementDetail(data) {
  return request({
    url: '/api/v3/kkpartners/report/async-download-settlement-detail',
    method: 'get',
    data
  })
}

// 检测异步下载结账报表详情任务
export function checkDownloadSettlementDetailTask(data) {
  return request({
    url: '/api/v3/kkpartners/report/check-download-settlement-detail-task',
    method: 'get',
    data
  })
}

// 對帳單取得 settle_statement_get_list
export function getSettleSettlementList(data) {
  return request({
    url: '/api/v3/kkpartners/statement/get-list',
    method: 'get',
    data
  })
}

// 對帳單取得 settle_statement_get_pdf_file
export function getStatementPdfFile(data) {
  return request({
    url: '/api/v3/kkpartners/statement/get-pdf-file',
    method: 'get',
    data
  })
}

// 對帳單儲存 settle_statement_save
export function saveStatement(data) {
  return request({
    url: '/api/v3/manage/statement/save',
    method: 'post',
    data
  })
}

// 点击数
export function getCidDailyClicks(data) {
  return request({
    url: '/api/v3/kkpartners/report/get-cid-daily-clicks',
    method: 'get',
    data
  })
}

// 商品转换率
export function getCidCvr(data) {
  return request({
    url: '/api/v3/kkpartners/report/get-cid-cvr',
    method: 'get',
    data
  })
}

// 行销成效图表数据
export function getPerformanceChart(data) {
  return request({
    url: '/api/v3/kkpartners/report/get-performance-chart',
    method: 'get',
    data
  })
}

// 保存发票
export function saveInvoice(data) {
  return request({
    url: '/api/v3/kkpartners/invoice/save',
    method: 'post',
    data
  })
}

// 获取数据统计
export function getDashboardOverview(data) {
  return request({
    url: '/api/v3/kkpartners/report/get-dashboard-overview',
    method: 'get',
    data
  })
}

// 取得佣金比例
export function getAffiliateTag() {
  return request({
    url: '/api/v3/kkpartners/affiliate-tag/get-list',
    method: 'get'
  })
}

// 搜索商品分润
export function getAffiliateTagProd(data) {
  return request({
    url: '/api/v3/kkpartners/affiliate-tag/get-prod-list',
    method: 'get',
    data
  })
}

// 联盟端通知列表
export function getNotificationListApi(data) {
  return request({
    url: '/api/v3/kkpartners/notification/get-list',
    method: 'get',
    data
  })
}

// 联盟端通知已读
export function readNotificationApi(data) {
  return request({
    url: '/api/v3/kkpartners/notification/update',
    method: 'post',
    data
  })
}

// 删除发票
export function deleteInvoice(data) {
  return request({
    url: '/api/v3/manage/invoice/delete',
    method: 'post',
    data
  })
}

// 联盟-活动列表
export function getAffiliateEventList(data) {
  return request({
    url: '/api/v3/kkpartners/event/get-list',
    method: 'get',
    data
  })
}

// 联盟-活动详情
export function getAffiliateEventInfo(data) {
  return request({
    url: '/api/v3/kkpartners/event/get-info',
    method: 'get',
    data
  })
}

// 编辑kkpartners已推送的新功能
export function editFunctionNotice(data) {
  return request({
    url: '/api/v3/kkpartners/account/edit-function-notice',
    method: 'post',
    data
  })
}

// 编辑联盟网站
export function editPlatform(data) {
  return request({
    url: '/api/v3/kkpartners/web/edit-platform',
    method: 'post',
    data
  })
}

// KKday聯盟行銷計畫合作協議
export function getMemberContract(data) {
  return request({
    url: '/api/v3/kkpartners/commission-rule/get-member-contract',
    method: 'get',
    data
  })
}

// 获取cid附录分润规则信息
export function getCidAppendixRuleList(data) {
  return request({
    url: '/api/v3/kkpartners/commission-rule/get-cid-appendix-rule-list',
    method: 'get',
    data
  })
}

// 获取赞助计划列表
export function getSponsorApplicationList(data) {
  return request({
    url: '/api/v3/kkpartners/sponsor-application/get-list',
    method: 'get',
    data
  })
}

// 获取赞助计划详情
export function getSponsorApplicationInfo(data) {
  return request({
    url: '/api/v3/kkpartners/sponsor-application/get-info',
    method: 'get',
    data
  })
}

// 新增赞助计划
export function addSponsorApplication(data) {
  return request({
    url: '/api/v3/kkpartners/sponsor-application/add',
    method: 'post',
    data
  })
}

// 获取赞助计划商品列表
export function getSponsorApplicationProdList(data) {
  return request({
    url: '/api/v3/kkpartners/sponsor-application/get-prod-list',
    method: 'get',
    data
  })
}

// 获取商品信息
export function getSponsorApplicationProdInfo(data) {
  return request({
    url: '/api/v3/kkpartners/sponsor-application/get-prod-info',
    method: 'get',
    data
  })
}

// 检查联盟用户是否可签署劳保单
export function checkMemberSignStatus(data) {
  return request({
    url: '/api/v3/kkpartners/labor-statement/check-member-sign-status',
    method: 'get',
    data
  })
}

// 获取劳保单列表
export function getLaborStatementList(data) {
  let url = '/api/v3/kkpartners/labor-statement/get-list'
  if (localStorage.getItem('extraChannel') === 'MANAGE') {
    url = '/api/v3/manage/labor-statement/get-list'
  }
  return request({
    url,
    method: 'get',
    data
  })
}

// 获取劳保单详情
export function getLaborStatementInfo(data) {
  let url = '/api/v3/kkpartners/labor-statement/get-info'
  if (localStorage.getItem('extraChannel') === 'MANAGE') {
    url = '/api/v3/manage/labor-statement/get-info'
  }
  return request({
    url,
    method: 'get',
    data
  })
}

// 签署劳报单
export function signLaborStatement(data) {
  return request({
    url: '/api/v3/kkpartners/labor-statement/sign',
    method: 'post',
    data
  })
}

// 获取语系列表
export function getProductMediaLangList(data) {
  return request({
    url: 'api/v3/common/get-product-media-lang-list',
    method: 'get',
    data
  })
}

// 获取币种列表
export function getCurrencyList(data) {
  return request({
    url: 'api/v3/common/get-product-media-currency-list',
    method: 'get',
    data
  })
}

// 获取商品城市列表
export function getProductCityList(data) {
  return request({
    url: 'api/v3/common/get-product-city-list',
    method: 'get',
    data
  })
}

// 获取商品分类列表
export function getProductCategoryList(data) {
  return request({
    url: 'api/v3/common/get-product-category-list',
    method: 'get',
    data
  })
}

// 管理端搜寻商品列表
export function productMediaSearchProduct(data) {
  return request({
    url: 'api/v3/kkpartners/product-media/search-product',
    method: 'get',
    data
  })
}

// 第三方网站搜寻商品列表
export function searchProduct(data) {
  return request({
    url: 'api/v3/product-media/search-product',
    method: 'get',
    data
  })
}

// 获取客制化分润规则信息
export function getCommissionRuleInfo(data) {
  return request({
    url: 'api/v3/kkpartners/commission-rule/get-info',
    method: 'get',
    data
  })
}

// 获取商品清单
export function commissionRuleSearchProductList(data) {
  return request({
    url: 'api/v3/kkpartners/commission-rule/search-product-list',
    method: 'post',
    data
  })
}

// 审核联盟网址平台
export function reviewPlatformUrl(data) {
  return post('/api/v3/kkpartners/web-platform/review-url', data)
}
